import { Box, FileLink, Pill, Typography } from 'web-library';
import { AnnouncementDetail } from 'web-library/models/Announcements';
import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { stringToSemanticDisplay } from '../../../utils/DateUtils';

const useStyles = makeStyles()((theme) =>
({
  cardHeaderContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 34,
  },
  dateContainer: {
    color: theme.color.text.textTertiary,
    marginBottom: theme.spacing(1.5),
  },
  titleContainer: {
    color: theme.color.text.textPrimary,
    marginBottom: theme.spacing(1),
  },
  descriptionContainer: {
    fontWeight: 400,
    marginBottom: theme.spacing(4),
  },
  fileContainer: {
    marginBottom: theme.spacing(3),
  },
}));

interface AnnouncementSingleContentProps {
  announcementNoticeDetails: AnnouncementDetail;
}

const AnnouncementSingleContent = ({
  announcementNoticeDetails,
}: AnnouncementSingleContentProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      {announcementNoticeDetails?.announcementStartDate && (
        <Box className={classes.cardHeaderContent}>
          {announcementNoticeDetails?.announcementStartDate && (
            <Typography variant="subtitle2" className={classes.dateContainer}>
              {stringToSemanticDisplay(announcementNoticeDetails?.announcementStartDate || '')}
            </Typography>
          )}
          {announcementNoticeDetails?.priority && (
            <Pill label={t('admin->>AnnouncementNoticeBoard.Priority')} variant="warning" />
          )}
        </Box>
      )}
      {announcementNoticeDetails?.title && (
        <Typography variant="h4" className={classes.titleContainer}>
          {announcementNoticeDetails?.title}
        </Typography>
      )}
      {announcementNoticeDetails?.description && (
        <Typography variant="body1" className={classes.descriptionContainer}>
          {parse(announcementNoticeDetails?.description || '')}
        </Typography>
      )}
      {announcementNoticeDetails?.files && (
        <Box className={classes.fileContainer}>
          {announcementNoticeDetails?.files?.map((fileInfo) => (
            <FileLink key={fileInfo.url} fileInfo={fileInfo} />
          ))}
        </Box>
      )}
    </>
  );
};

export default AnnouncementSingleContent;
